var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isMetamaskMobile
    ? _c(
        "header",
        {
          staticClass: "header",
          class: {
            opacity: _vm.opacity,
            colored: _vm.colored,
            simple: _vm.simple,
            metamask: _vm.metamask,
          },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "header-inner" }, [
              _c(
                "div",
                { staticClass: "header-left" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "logo",
                      attrs: { to: { name: "Spotlight" } },
                    },
                    [
                      _c("img", {
                        staticClass: "logo-img",
                        attrs: {
                          src: "/public/img/logoLogin.png",
                          width: "36",
                          height: "33",
                          loading: "lazy",
                          alt: "logo",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "87",
                            height: "16",
                            viewBox: "0 0 87 16",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M12.2611 2.4018C12.945 2.4018 13.4288 1.90146 13.4288 1.20103C13.4288 0.500342 12.945 0 12.2611 0C11.5775 0 11.0938 0.500342 11.0938 1.20103C11.0938 1.90146 11.5775 2.4018 12.2611 2.4018ZM7.28827 5.07829C7.28827 3.64379 6.33754 2.94336 4.66956 2.94336H2.23438V7.26318H4.66956C6.33754 7.26318 7.28827 6.54619 7.28827 5.07829ZM9.40737 5.01566C9.40737 7.68458 7.72256 9.23556 4.78703 9.23556H2.2351V12.6714H0V0.996094H4.78703C7.72256 0.996094 9.40737 2.44716 9.40737 5.01566ZM11.1758 12.6716H13.3441V3.74805H11.1758V12.6716ZM17.58 3.74802L19.4312 6.65042L21.3329 3.74802H23.7179L20.8823 8.10123L23.918 12.6716H21.416L19.4312 9.55256L17.2797 12.6716H14.8614L17.9802 8.10123L15.078 3.74802H17.58ZM26.4368 8.22644C26.4368 6.65863 27.4375 5.59117 28.872 5.59117C29.8561 5.59117 30.6402 5.95795 31.207 6.57529L32.5248 5.3243C31.7242 4.29023 30.4233 3.68945 28.7887 3.68945C26.1035 3.68945 24.252 5.52439 24.252 8.24301C24.252 10.9285 26.0866 12.7632 28.7553 12.7632C30.5066 12.7632 31.841 12.0961 32.625 10.9619L31.2738 9.84447C30.7401 10.5449 29.9061 10.8951 28.872 10.8951C27.4375 10.8951 26.4368 9.82764 26.4368 8.22644ZM43.2543 7.1077V12.6785H41.0694V7.7416C41.0694 6.49062 40.3188 5.72341 39.0846 5.72341C37.6167 5.74024 36.7328 6.82401 36.7328 8.2919V12.6785H34.5645V0.302734H36.7328V5.45654C37.3664 4.23895 38.4841 3.68839 39.9517 3.67183C42.0033 3.67183 43.2543 4.98933 43.2543 7.1077ZM54.2762 12.6733V3.74973H52.1079V5.18423C51.4575 4.20037 50.4068 3.64981 49.0391 3.66638C46.5371 3.6832 44.8691 5.50131 44.8691 8.18654C44.8691 10.9054 46.5705 12.7735 49.1224 12.7735C50.4568 12.7735 51.4743 12.2229 52.1079 11.2554V12.6733H54.2762ZM52.1103 8.56109V7.92719C51.977 6.49294 50.9929 5.52539 49.5917 5.52539C48.1073 5.52539 47.0732 6.65964 47.0566 8.24401C47.0732 9.84547 48.0907 10.9629 49.5917 10.9629C50.9929 10.9629 51.977 9.9956 52.1103 8.56109ZM65.6342 12.6815V7.11068C65.6342 4.99231 64.3832 3.6748 62.3317 3.6748C60.8806 3.69137 59.7632 4.24193 59.1293 5.42613V3.75815H56.9609V12.6815H59.1293V8.29488C59.1293 6.82699 59.9966 5.74321 61.4645 5.72639C62.6987 5.72639 63.4493 6.4936 63.4493 7.74458V12.6815H65.6342ZM76.2294 3.75662V11.8297C76.2294 14.3813 74.3782 15.9993 71.5591 15.9993C70.1249 15.9993 68.8405 15.5321 67.7896 14.8151L68.657 13.2471C69.4744 13.8478 70.3749 14.1815 71.4424 14.1815C73.0436 14.1815 74.0611 13.2973 74.0611 11.8796V10.829C73.4606 11.7295 72.4933 12.2298 71.2257 12.2298C68.8573 12.2298 67.2559 10.4951 67.2559 7.92657C67.2559 5.40803 68.8405 3.68984 71.1589 3.68984C72.4433 3.67327 73.444 4.19044 74.0611 5.09121V3.75662H76.2294ZM71.6919 5.43066C73.093 5.43066 74.0603 6.48131 74.0603 7.98233C74.0603 9.48362 73.093 10.5343 71.6919 10.5343C70.2742 10.5343 69.3235 9.48362 69.3066 7.98233C69.3235 6.49813 70.2908 5.43066 71.6919 5.43066ZM85.3035 9.78701L86.5714 10.9544C85.5538 12.1717 84.2195 12.7725 82.6517 12.7725C79.866 12.7725 77.9648 10.9544 77.9648 8.23551C77.9648 5.58367 79.7162 3.7156 82.4847 3.69878C84.9702 3.66539 86.6379 5.20006 86.7549 7.68521L80.3998 9.48649C80.817 10.454 81.6842 11.038 82.8018 11.038C83.7357 11.038 84.6031 10.6042 85.3035 9.78701ZM84.633 6.75936L80.1465 8.04348C80.1799 6.32554 81.1138 5.4082 82.5982 5.4082C83.5824 5.4082 84.2662 5.8252 84.633 6.75936Z",
                              fill: "black",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "header-navigation" },
                [
                  _vm.isAuthenticated
                    ? _c(
                        "span",
                        {
                          staticClass: "login-link",
                          attrs: { id: "login-link" },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.toMyProfile.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm.userAvatar
                                ? [
                                    _c("img", {
                                      staticClass: "avatar",
                                      attrs: {
                                        src: _vm.userAvatar,
                                        width: "24",
                                        height: "24",
                                        loading: "lazy",
                                        alt: "avatar",
                                      },
                                    }),
                                  ]
                                : _c(
                                    "svg",
                                    {
                                      staticClass: "avatar",
                                      attrs: {
                                        width: "28",
                                        height: "27",
                                        viewBox: "0 0 28 27",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M14.0009 26.8709C21.3225 26.8709 27.2713 20.922 27.2713 13.6005C27.2713 6.27894 21.3224 0.330078 14.0009 0.330078C6.67933 0.330078 0.730469 6.27894 0.730469 13.6005C0.730469 20.922 6.67933 26.8709 14.0009 26.8709ZM6.67927 21.9781C8.68579 19.5844 11.2904 18.282 14.0009 18.282C16.7113 18.282 19.316 19.5844 21.3225 21.9781C19.3864 23.7028 16.8169 24.7588 14.0009 24.7588C11.1849 24.7588 8.61527 23.7027 6.67927 21.9781ZM14.0009 2.44208C20.1609 2.44208 25.1593 7.44048 25.1593 13.6005C25.1593 16.17 24.2793 18.5637 22.8009 20.4293C20.372 17.6837 17.3097 16.17 14.0009 16.17C10.692 16.17 7.62967 17.6834 5.20087 20.4293C3.72247 18.5286 2.84247 16.17 2.84247 13.6005C2.84247 7.44048 7.84087 2.44208 14.0009 2.44208Z",
                                          fill: "black",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d: "M14.0009 15.115C16.9576 15.115 19.3513 12.7215 19.3513 9.76453C19.3513 6.80779 16.9578 4.41406 14.0009 4.41406C11.0441 4.41406 8.65039 6.80754 8.65039 9.76453C8.65039 12.7215 11.0441 15.115 14.0009 15.115ZM14.0009 6.52619C15.796 6.52619 17.2393 7.96945 17.2393 9.76459C17.2393 11.5597 15.796 13.003 14.0009 13.003C12.2057 13.003 10.7625 11.5597 10.7625 9.76459C10.7625 8.00459 12.2057 6.52619 14.0009 6.52619Z",
                                          fill: "black",
                                        },
                                      }),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c("span", { staticClass: "username" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.currentUser.username) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            2
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.simple
                    ? [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isAuthenticated && !_vm.opacity,
                                expression: "!isAuthenticated && !opacity",
                              },
                            ],
                            staticClass: "app-links mobile-hide",
                          },
                          [
                            _c("IosLink", { attrs: { small: "" } }),
                            _vm._v(" "),
                            _c("AndroidLink", { attrs: { small: "" } }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isAuthenticated && !_vm.simple
                          ? _c(
                              "Teleport",
                              {
                                attrs: {
                                  to: "#coins-mobile",
                                  disabled: _vm.teleportDisable,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.currency,
                                        expression: "currency",
                                      },
                                    ],
                                    staticClass: "coins-wrapper",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "coins nft-icon",
                                        on: {
                                          click: function ($event) {
                                            return _vm.purchaseModalOpen(true)
                                          },
                                        },
                                      },
                                      [
                                        _c("number", {
                                          ref: "pixtokens",
                                          staticClass: "coins-value",
                                          attrs: {
                                            from: _vm.oldPxtValue,
                                            to: _vm.newPxtValue,
                                            duration: _vm.duration,
                                            animationPaused: "",
                                            easing: "Power1.easeOut",
                                          },
                                          on: {
                                            complete: function ($event) {
                                              return _vm.counterAnimation(
                                                "pixtokens"
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "coins pixcoin-icon",
                                        on: {
                                          click: function ($event) {
                                            return _vm.purchaseModalOpen(false)
                                          },
                                        },
                                      },
                                      [
                                        _c("number", {
                                          ref: "pixcoins",
                                          staticClass: "coins-value",
                                          attrs: {
                                            from: _vm.oldPxValue,
                                            to: _vm.newPxValue,
                                            duration: _vm.duration,
                                            delay: _vm.delay,
                                            animationPaused: "",
                                            easing: "Power1.easeOut",
                                          },
                                          on: {
                                            complete: function ($event) {
                                              return _vm.counterAnimation(
                                                "pixcoins"
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isAuthenticated
                    ? _c(
                        "span",
                        {
                          staticClass: "login-link",
                          attrs: { id: "login-link" },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.toMyProfile.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "avatar",
                                  attrs: {
                                    width: "28",
                                    height: "27",
                                    viewBox: "0 0 28 27",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M14.0009 26.8709C21.3225 26.8709 27.2713 20.922 27.2713 13.6005C27.2713 6.27894 21.3224 0.330078 14.0009 0.330078C6.67933 0.330078 0.730469 6.27894 0.730469 13.6005C0.730469 20.922 6.67933 26.8709 14.0009 26.8709ZM6.67927 21.9781C8.68579 19.5844 11.2904 18.282 14.0009 18.282C16.7113 18.282 19.316 19.5844 21.3225 21.9781C19.3864 23.7028 16.8169 24.7588 14.0009 24.7588C11.1849 24.7588 8.61527 23.7027 6.67927 21.9781ZM14.0009 2.44208C20.1609 2.44208 25.1593 7.44048 25.1593 13.6005C25.1593 16.17 24.2793 18.5637 22.8009 20.4293C20.372 17.6837 17.3097 16.17 14.0009 16.17C10.692 16.17 7.62967 17.6834 5.20087 20.4293C3.72247 18.5286 2.84247 16.17 2.84247 13.6005C2.84247 7.44048 7.84087 2.44208 14.0009 2.44208Z",
                                      fill: "black",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M14.0009 15.115C16.9576 15.115 19.3513 12.7215 19.3513 9.76453C19.3513 6.80779 16.9578 4.41406 14.0009 4.41406C11.0441 4.41406 8.65039 6.80754 8.65039 9.76453C8.65039 12.7215 11.0441 15.115 14.0009 15.115ZM14.0009 6.52619C15.796 6.52619 17.2393 7.96945 17.2393 9.76459C17.2393 11.5597 15.796 13.003 14.0009 13.003C12.2057 13.003 10.7625 11.5597 10.7625 9.76459C10.7625 8.00459 12.2057 6.52619 14.0009 6.52619Z",
                                      fill: "black",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "username" }, [
                                _vm._v(" Login "),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.headerType !== "metamaskTemplate"
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.opacity,
                              expression: "!opacity",
                            },
                          ],
                          staticClass: "burger",
                          on: { click: _vm.menuToggle },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "29",
                                height: "20",
                                viewBox: "0 0 29 20",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M2 10H27",
                                  stroke: "black",
                                  "stroke-width": "3.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M2 2H27",
                                  stroke: "black",
                                  "stroke-width": "3.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M2 18H27",
                                  stroke: "black",
                                  "stroke-width": "3.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.purchaseModal
            ? _c("PurchaseModal", {
                attrs: { pixtokens: _vm.pixtokens },
                on: {
                  modalClose: _vm.purchaseModalClose,
                  currencyUpdateCheck: _vm.currencyUpdateCheck,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.successBuy
            ? _c("SuccessBuyModal", {
                attrs: { data: _vm.successBuyData },
                on: { modalClose: _vm.successBuyModalClose },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }